import {
  netClient,
  type CommonResponse,
  MEMORIAL_GIFT_LIST,
  MEMORIAL_MESSAGE_CREATE,
  MEMORIAL_MESSAGE_LIST,
  MEMORIAL_ADD_PRELOAD,
  MEMORIAL_ADD_ONE_LIFE_PRELOAD,
  MEMORIAL_ADD_LIFE_ARTICLE,
  MEMORIAL_EDIT_LIFE_ARTICLE,
  MEMORIAL_LIFE_ARTICLE,
  MEMORIAL_LIST_LIFE_ARTICLE,
  MEMORIAL_POST_ADD_PHOTO,
  MEMORIAL_LIST_PHOTO_FILE,
  MEMORIAL_POST_LIST_PHOTO,
  MEMORIAL_STORY_ADD,
  MEMORIAL_STORY_LIST,
  MEMORIAL_MESSAGE,
  MEMORIAL_INVITATION_CREATE,
  MEMORIAL_INVITATION_ACCEPT,
  MEMORIAL_INVITATION,
  MEMORIAL_POST,
  LIFE_FILE_EDIT_DESC,
  SERVICE_PRIVILEGES,
  SERVICE_PRIVILEGE_CHANGE,
  THEME_PRE_GET,
  THEME_SELECT,
  MEMORIAL_POST_PRE_LOAD,
  MARTICLE_TEMPLATES,
  MEMORIAL_COMMENT_THANKS,
  REPORT_PV,
  LIST_FAVORITE_LIFE,
  SEARCH_FAVORITE_LIFE,
  VISIT_OPEN_LIFE,
  SERVICE_PRIVILEGE_DELETE,
  FAMILY_NAMES,
  FAMILY_NAMES_LIVES,
  PUBLIC_FIGURE_CATEGORIES,
  PUBLIC_FIGURE_CATEGORY,
  MEMORIAL_REPORT,
  MEMORIAL_CLAIM
} from '@/apis/api'
import type { Name, UserMinDTO } from '../user/users'
import type { FileDTO } from '../media/media'
import { ref, type Ref } from 'vue'
import type { LifeDTO, MemorialArticleDTO, MemorialPrivilegeDTO, Permission, RelationDTO } from '../life/life'
import type { LifeAnniversaryDTO } from '../schedule/schedule'
// export type { ThemeColors } from '../settings/definition'
import type { ReportPvCommand } from '../obituary/obituary'

export interface MultiLang {
  data: Record<string, string>
  key: string
}
const _globalShowMemorialPrivilegeDialog = ref<boolean>(false)
export const globalShowMemorialPrivilegeDialog = _globalShowMemorialPrivilegeDialog
export const globalName = ref('')
export const globalAvatarUrl = ref('')
export const globalInviteButtonRef = ref<any>(null)
export const globalServiceId = ref('')
export const globalYearPeriod = ref('')
export const globalOnClose = () => {
  setTimeout(() => {
    globalShowMemorialPrivilegeDialog.value = false
  }, 100)
}

export interface MemorialGiftDTO {
  serialVersionUID: number
  id: string
  giftName: string
  type: string
  memberOnly: boolean
  outdated: boolean
  price: number // 原价
  memberPrice: number // 会员价
  categories: Array<string>
  words: MultiLang
  giftNames: MultiLang
  file: FileDTO
  rank: number
  pack: boolean
  idsInPack: Array<string>
  anim: string
}

export const MSG_TXT = 0
export const MSG_GIFT = 1
export type MsgType = 0 | 1

export interface MemorialMessageDTO {
  id: string
  lifeId: string
  serviceId: string
  gift: MemorialGiftDTO
  content: string
  tags: Array<Tag>
  msgType: MsgType
  thanksId: string
  thanks: CommentThanksDTO
  creator: UserMinDTO
  relation: RelationDTO
  createdAt: number
}

export interface CommentThanksCommand {
  messageId: string
  contentText: string
  thankName: string
}

export function commentThanks(commentThanksCommand: CommentThanksCommand) {
  return netClient.request<CommonResponse<CommentThanksDTO>>(MEMORIAL_COMMENT_THANKS, 'post', commentThanksCommand)
}

export interface CommentThanksDTO {
  id: string
  messageId: string
  thanksTo: string
  thankName: string
  contentText: string
  thankBy: string
  templateNotify: boolean
  smsNotify: boolean
  thankByUser: UserMinDTO
  createdAt: number
}

/**
 * @param level 1-普通 2-会员
 * @returns
 */
export function listGift(level: number) {
  return netClient.request<CommonResponse<Array<MemorialGiftDTO>>>(MEMORIAL_GIFT_LIST, 'get', { level: level })
}

export interface ExampleArticleDTO {
  title: string
  tag: string
  content: string
}

export interface PreloadAddMemoryResponse {
  relation: RelationDTO
  exampleArticles: Array<ExampleArticleDTO>
  anniversaries: Array<LifeAnniversaryDTO>
}

export function reloadAddMemory(serviceId: string) {
  return netClient.request<CommonResponse<PreloadAddMemoryResponse>>(MEMORIAL_ADD_PRELOAD, 'get', {
    serviceId: serviceId
  })
}

export interface CreateMemorialMessageBody {
  content: string | null
  giftId: string | null
  serviceId: string
  relationCode: string | null
  relationName: string | null
  tags: Array<Tag>
  msgType: number
}

export interface ListMessageResponse {
  page: number
  pageSize: number
  total: number
  totalPages: number
  items: Array<MemorialMessageDTO>
}

export interface RemoveMemorialMessageResponse {
  msgId: string
}
export function createMemorialMessage(body: CreateMemorialMessageBody) {
  console.log('==body:', body)
  return netClient.request<CommonResponse<RemoveMemorialMessageResponse>>(MEMORIAL_MESSAGE_CREATE, 'post', body)
}

export function listMemorialMessages(serviceId: string, last: string, pageSize: number, type: number) {
  return netClient.request<CommonResponse<ListMessageResponse>>(MEMORIAL_MESSAGE_LIST, 'get', {
    serviceId: serviceId,
    last: last,
    pageSize: pageSize,
    type: type
  })
}

export interface RemoveMemorialMessageResponse {
  msgId: string
}

export function deleteMemorialMessage(msgId: string) {
  return netClient.request<CommonResponse<RemoveMemorialMessageResponse>>(MEMORIAL_MESSAGE + '/' + msgId, 'delete', {})
}

// ============  life articles
// preload add ones life
export interface AddOnesLifePreloadResponse {
  relation: RelationDTO
  exampleArticles: Array<string>
}

export function preloadAddOnesLife(serviceId: string) {
  return netClient.request<CommonResponse<AddOnesLifePreloadResponse>>(MEMORIAL_ADD_ONE_LIFE_PRELOAD, 'get', {
    serviceId: serviceId
  })
}

// life article
export interface LifeArticleDTO {
  id: string
  content: string
  lifeId: string
  serviceId: string
  creator: UserMinDTO
  updater: UserMinDTO
  creatorRelation: RelationDTO
  updaterRelation: RelationDTO
  createdAt: number
  updatedAt: number
}

export interface CreateLifeArticleBody {
  content: string
  serviceId: string
  relationCode: string
  relationName: string
}

export interface CreateLifeArticleResponse {
  lifeArticleId: string
}

// add
export function createLifeArticle(createBody: CreateLifeArticleBody) {
  return netClient.request<CommonResponse<CreateLifeArticleResponse>>(MEMORIAL_ADD_LIFE_ARTICLE, 'post', createBody)
}

// get
export function getLifeArticle(lifeArticleId: string) {
  return netClient.request<CommonResponse<LifeArticleDTO>>(MEMORIAL_LIFE_ARTICLE + '/' + lifeArticleId, 'get', {})
}

// edit
export interface EditLifeArticleBody {
  articleId: string
  content: string
  relationCode: string
  relationName: string
}

export interface EditLifeArticleResponse {
  lifeArticleId: string
}

export function editLifeArticle(editBody: EditLifeArticleBody) {
  return netClient.request<CommonResponse<EditLifeArticleResponse>>(MEMORIAL_EDIT_LIFE_ARTICLE, 'post', editBody)
}

// list
export interface ListLifeArticleResponse {
  pageSize: number
  total: number
  id: string
  items: Array<LifeArticleDTO>
}

export function listLifeArticle(serviceId: string, last: string | null, pageSize: number) {
  return netClient.request<CommonResponse<ListLifeArticleResponse>>(
    MEMORIAL_LIST_LIFE_ARTICLE,
    'get',
    last
      ? {
          serviceId: serviceId,
          last: last,
          pageSize: pageSize
        }
      : {
          serviceId: serviceId,
          pageSize: pageSize
        }
  )
}

// delete
export interface DeleteLifeArticleResponse {
  lifeArticleId: string
}
export function deleteLifeArticle(lifeArticleId: string) {
  return netClient.request<CommonResponse<DeleteLifeArticleResponse>>(
    MEMORIAL_LIFE_ARTICLE + '/' + lifeArticleId,
    'delete',
    {
      id: lifeArticleId
    }
  )
}

// create photo post
export interface MemorialPostDTO {
  id: string
  postType: string
  lifeId: string
  content: string
  files: Array<LifeFileDTO>
  creator: UserMinDTO
  updater: UserMinDTO
  creatorRelation: RelationDTO
  updaterRelation: RelationDTO
  createdAt: number
  updatedAt: number
  tags: Array<Tag>
}

export interface LifeFileDTO {
  id: string
  description: string
  lifeId: string
  postId: string
  creator: UserMinDTO
  updater: UserMinDTO
  file: FileDTO
  enhancedFile: FileDTO
  coloredFile: FileDTO
  createdAt: number
  updatedAt: number
  avatar: boolean
}

export interface Tag {
  key: string
  name: string
}

export interface AddPostCommand {
  serviceId: string
  content: string
  tags: Array<Tag>
  attachments: Array<AttachmentIn>
}

export interface AttachmentIn {
  name: string
  url: string
  description: string
  size: number
  w: number
  h: number
  type: number
  contentType: string
  coverFileId: string
  folderIds: Array<string>
  year: string
}

export interface CreatePostResponse {
  postId: string
}

export interface ListMemorialPostResponse {
  page: number
  pageSize: number
  total: number
  totalPages: number
  items: Array<MemorialPostDTO>
  nonMemberStorageOverflow: boolean
}

export interface ListMemorialFileResponse {
  id: string
  pageSize: number
  total: number
  items: Array<LifeFileWithRelationDTO>
  nonMemberStorageOverflow: boolean
}

export interface FolderWrapper {
  fileId: string
  commonFolderIds: Array<string>
  yearFolderId: string
  year: string
}

export interface LifeFileWithRelationDTO {
  id: string
  rank: number
  description: string
  lifeId: string
  serviceId: string
  postId: string
  creator: UserMinDTO
  updater: UserMinDTO
  creatorRelation: RelationDTO
  updaterRelation: RelationDTO
  file: FileDTO
  enhancedFile: FileDTO
  coloredFile: FileDTO
  createdAt: number
  updatedAt: number
  folder: FolderWrapper
  avatar: boolean
}

export function addPhotoPost(type: string, addPhotoCommand: AddPostCommand) {
  return netClient.request<CommonResponse<CreatePostResponse>>(
    MEMORIAL_POST_ADD_PHOTO.replace('{type}', type),
    'post',
    addPhotoCommand
  )
}

export function listPhotosByPage(
  serviceId: string,
  mediaType: string,
  last: string | null,
  lastRank: number,
  pageSize: number
) {
  return netClient.request<CommonResponse<ListMemorialFileResponse>>(
    MEMORIAL_LIST_PHOTO_FILE.replace('{type}', mediaType),
    'get',
    last
      ? {
          serviceId: serviceId,
          last: last,
          lastRank: lastRank,
          pageSize: pageSize
        }
      : {
          lastRank: lastRank,
          serviceId: serviceId,
          pageSize: pageSize
        }
  )
}

export function deletePostById(postId: string) {
  return netClient.request<CommonResponse<DeleteLifeArticleResponse>>(MEMORIAL_POST + '/' + postId, 'delete', {})
}

export function listMediaPostByPage(serviceId: string, last: string | null, pageSize: number) {
  return netClient.request<CommonResponse<ListMemorialPostResponse>>(
    MEMORIAL_POST_LIST_PHOTO,
    'get',
    last
      ? {
          serviceId: serviceId,
          last: last,
          pageSize: pageSize
        }
      : {
          serviceId: serviceId,
          pageSize: pageSize
        }
  )
}

export function addStoryPost(addStoryCommand: AddPostCommand) {
  return netClient.request<CommonResponse<CreatePostResponse>>(MEMORIAL_STORY_ADD, 'post', addStoryCommand)
}

export function listStoryPostByPage(serviceId: string, last: string | null, pageSize: number) {
  return netClient.request<CommonResponse<ListMemorialPostResponse>>(
    MEMORIAL_STORY_LIST,
    'get',
    last
      ? {
          serviceId: serviceId,
          last: last,
          pageSize: pageSize
        }
      : {
          serviceId: serviceId,
          pageSize: pageSize
        }
  )
}

export const mediaPreviewIndex = ref(0)
export const mediaPreviewList: Ref<Array<LifeFileWithRelationDTO>> = ref([])
export const mediaPreviewType = ref('')
const _isMediaPreviewOpen = ref<boolean>(false)
export const isMediaPreviewOpen = _isMediaPreviewOpen
const _isCreatorMember = ref<boolean>(false)
export const isCreatorMember = _isCreatorMember
const _mediaCanEdit = ref<boolean>(false)
export const mediaCanEdit = _mediaCanEdit
const _sourceShouldRefresh = ref<boolean>(false)
export const sourceShouldRefresh = _sourceShouldRefresh
const _isInMediaFolder = ref<boolean>(false)
export const isInMediaFolder = _isInMediaFolder
const _isMediaDeletable = ref<boolean>(true)
export const isMediaDeletable = _isMediaDeletable

export function closeMediaPreview() {
  isMediaPreviewOpen.value = false
  mediaCanEdit.value = false
  mediaPreviewList.value = []
  mediaPreviewIndex.value = 0
  mediaCanEdit.value = false
}

export const TYPE_IMG = '1'
export const TYPE_VIDEO = '2'
export const TYPE_STORY = '3'
export const TYPE_AUDIO = '4'

// --- invitation & privileges
export interface CreateInvitationCommand {
  serviceId: string
  role: string
  expireAt: string
}

export interface AcceptInvitationCommand {
  invitationCode: string
}

export interface MemorialInvitationResponse {
  invitationCode: string
}

export function createInvitation(createInvitationCommand: CreateInvitationCommand) {
  return netClient.request<CommonResponse<MemorialInvitationResponse>>(
    MEMORIAL_INVITATION_CREATE,
    'post',
    createInvitationCommand
  )
}

export function acceptInvitation(acceptInvitationCommand: AcceptInvitationCommand) {
  return netClient.request<CommonResponse<unknown>>(MEMORIAL_INVITATION_ACCEPT, 'post', acceptInvitationCommand)
}

export interface InvitationDetailDTO {
  lifeId: string
  serviceId: string
  lifeName: Name
  lifeAvatar: FileDTO
  invitor: UserMinDTO
  invitationCode: string
}

export interface InvitationDetailResponse {
  detail: InvitationDetailDTO
  memorialArticle: MemorialArticleDTO
  granted: boolean
  archived: boolean
}

export function getInvitationDetail(invitationCode: string) {
  return netClient.request<CommonResponse<Array<InvitationDetailResponse>>>(
    MEMORIAL_INVITATION + invitationCode,
    'get',
    {}
  )
}

export interface ServicePrivilegeDTO {
  lifeId: string
  serviceId: string
  userId: string
  user: UserMinDTO
  role: string
  permissions: Array<Permission>
}

export interface ListPrivilegesResponse {
  page: number
  pageSize: number
  total: number
  privileges: Array<ServicePrivilegeDTO>
}

export function getServicePrivileges(serviceId: string, lastId: string | null, pageSize: number) {
  console.log('last:', lastId)
  return netClient.request<CommonResponse<ListPrivilegesResponse>>(
    SERVICE_PRIVILEGES.replace('{serviceId}', serviceId),
    'get',
    lastId ? { last: lastId, pageSize: pageSize } : { pageSize: pageSize }
  )
}

export interface ChangePrivilegeCommand {
  userId: string
  role: string
}

export interface ChangePrivilegeResponse {
  privilege: ServicePrivilegeDTO
}

export interface DeletePrivilegeResponse {
  privilege: ServicePrivilegeDTO
}

export function changePrivilege(serviceId: string, changeCommand: ChangePrivilegeCommand) {
  return netClient.request<CommonResponse<ChangePrivilegeResponse>>(
    SERVICE_PRIVILEGE_CHANGE.replace('{serviceId}', serviceId),
    'post',
    changeCommand
  )
}

export function deletePrivilege(serviceId: string, targetUserId: string) {
  return netClient.request<CommonResponse<ServicePrivilegeDTO>>(
    SERVICE_PRIVILEGE_DELETE.replace('{serviceId}', serviceId),
    'delete',
    { userId: targetUserId }
  )
}

// theme
export interface PreGetThemeResponse {
  themes: Array<ThemeDTO>
  themeCategories: Array<ThemeCategory>
  selectedThemeId: string
}

export interface MusicDTO {
  id: string
  fileId: string
  file: FileDTO
  name: string
  author: string
  creatorId: string
  creator: UserMinDTO
  rank: number
}

export interface ThemeCategory {
  value: MultiLang
}

export interface ThemeDTO {
  id: string
  gifFile: FileDTO
  gifSmallFile: FileDTO
  file: FileDTO
  smallFile: FileDTO
  themeType: number
  category: string
  categoryModel: ThemeCategory
  musicIds: Array<String>
  playList: Array<MusicDTO>
  mode: number
  orderParam: number
  name: string
  colorValue: string
  memberOnly: boolean
  outdated: boolean
  toDefault: boolean
  themeColors: any
  createdAt: number
}

export interface CreateMemorialThemeCommand {
  serviceId: string
  themeId: string
}

export const THEME_LIGHT = 1
export const THEME_DARK = 2

export const THEME_TYPE_COLOR = 1
export const THEME_TYPE_COLOR_GRADIENT = 2
export const THEME_TYPE_PIC = 3
export const THEME_TYPE_VIDEO = 4

export function getThemes(serviceId: string) {
  return netClient.request(THEME_PRE_GET, 'get', { serviceId: serviceId })
}

export function selectTheme(themeCommand: CreateMemorialThemeCommand) {
  return netClient.request(THEME_SELECT, 'post', themeCommand)
}

export interface PostPreloadDTO {
  relation: RelationDTO
  anniversaries: Array<LifeAnniversaryDTO>
}

export function addPostPreload(serviceId: string) {
  return netClient.request<CommonResponse<PostPreloadDTO>>(MEMORIAL_POST_PRE_LOAD, 'get', { serviceId: serviceId })
}

// article template
export interface MemorialArticleTemplateDTO {
  id: string
  content: string
  lang: string
  relation: string
  creatorId: string
  updaterId: string
  createdAt: number
  updatedAt: number
}

export const getAllArticlepTemplates = (lang: string | null) => {
  return netClient.request<CommonResponse<Record<string, Array<MemorialArticleTemplateDTO>>>>(
    MARTICLE_TEMPLATES,
    'get',
    { lang: lang }
  )
}

const _showMArticleTemplateDialog = ref<boolean>(false)
export const showMArticleTemplateDialog = _showMArticleTemplateDialog
export const selectedMArticle: Ref<MemorialArticleTemplateDTO | undefined> = ref()

export const editLifeFileDesc = (lifeFileId: string, desc: string) => {
  return netClient.request<CommonResponse<LifeFileDTO>>(LIFE_FILE_EDIT_DESC, 'post', {
    lifeFileId: lifeFileId,
    description: desc
  })
}

export function report(reportCommand: ReportPvCommand) {
  return netClient.request<CommonResponse<string>>(REPORT_PV, 'post', reportCommand)
}

export interface ListFavoriteLifeCommand {
  lifeId: string | null // 分页用Lifeid，上一页最后一个
  page: number
  pageSize: number
  sort: string | null // 默认传null吧
}

export interface ListFavoriteLifeResponse {
  id: string
  pageSize: number
  total: number
  items: Array<LifeDTO>
  userCount: string | number // 用户数
  memorialCount: string | number // 纪念数 - 与官网保持一致
}

export function listFavoriteLife(listCommand: ListFavoriteLifeCommand) {
  return netClient.request<CommonResponse<ListFavoriteLifeResponse>>(LIST_FAVORITE_LIFE, 'get', listCommand)
}

export interface SearchFavoriteLifeCommand {
  name: string | null // 姓名关键词
  lifeId: string | null // 分页用Lifeid，上一页最后一个
  page: number
  pageSize: number
}
export interface SearchOpenLifeResponse {
  id: string
  pageSize: number
  total: number
  items: Array<LifeDTO>
}

export function searchOpenLife(searchCommand: SearchFavoriteLifeCommand) {
  return netClient.request<CommonResponse<SearchOpenLifeResponse>>(SEARCH_FAVORITE_LIFE, 'get', searchCommand)
}

export interface ListMyVisitedMemorialCommand {
  lifeId: string //上页最后一个
  page: number
  pageSize: number
  sort: string // 默认传null吧
}
export interface ListMyVisitedMemorialResponse {
  id: string
  pageSize: number
  total: number
  items: Array<LifeDTO>
}

export function listMyVisitedMemorial(listCommand: ListMyVisitedMemorialCommand) {
  return netClient.request<CommonResponse<ListMyVisitedMemorialResponse>>(VISIT_OPEN_LIFE, 'get', listCommand)
}

export interface FamilyNameDTO {
  familyName: string
  count: number
}

// response Array<FamilyNameDTO>

export function getFamilyNames() {
  return netClient.request<CommonResponse<Array<FamilyNameDTO>>>(FAMILY_NAMES, 'get', {})
}

// response
export interface GetOpenMemorialResponse {
  pageSize: number
  page: number
  total: number // 可以使用total和pageSize计算总共有多少页
  familyName: string
  lives: Array<LifeDTO>
}
//GET /v1/m/familyName/{name}?page=xxx&pageSize=50
export function getOpenMemorial(familyName: string, page: number, pageSize: number = 50) {
  return netClient.request<CommonResponse<GetOpenMemorialResponse>>(
    FAMILY_NAMES_LIVES.replace('{name}', familyName),
    'get',
    { page: page, pageSize: pageSize }
  )
}

// response Array<PublicFigureCategory>;

export interface PublicFigureCategory {
  key: string // 分类的key，用于下面的方法
  name: string // 展示名称
  count: number
}

export function getPublicFigureCategories() {
  return netClient.request<CommonResponse<Array<PublicFigureCategory>>>(PUBLIC_FIGURE_CATEGORIES, 'get', {})
}

// response
export interface GetPublicFigureResponse {
  pageSize: number
  page: number
  total: number
  familyName: string
  lives: Array<LifeDTO>
}

export function getPublicFigureCategory(key: string, page: number, pageSize: number = 50) {
  return netClient.request<CommonResponse<GetPublicFigureResponse>>(
    PUBLIC_FIGURE_CATEGORY.replace('{key}', key),
    'get',
    { page: page, pageSize: pageSize }
  )
}

//POST /v1/m:report
export interface ReportMemorialCommand {
  serviceId: string
  reason: string
  additionMsg: string
}

export function reportMemorial(reportCommand: ReportMemorialCommand) {
  return netClient.request<CommonResponse<string>>(MEMORIAL_REPORT, 'post', reportCommand)
}

//POST /v1/m:claim
export interface ClaimMemorialCommand {
  serviceId: string
  relation: string // 关系
  contactType: string // phone / wechat
  number: string // 号码
  imageId: string // 证明图片的id
}

export function claimMemorial(claimCommand: ClaimMemorialCommand) {
  return netClient.request<CommonResponse<string>>(MEMORIAL_CLAIM, 'post', claimCommand)
}
